<template>
    <div>
        <div class="d-flex justify-space-around mb-4">
            <h1 class="font-weight-light primary--text">Resumen</h1>
            <v-btn-toggle v-model="toggle_exclusive" color="primary" mandatory>
                <v-btn>
                    <v-icon>
                        mdi-view-list-outline
                    </v-icon>
                </v-btn>
                <v-btn>
                    <v-icon>
                        mdi-view-grid-outline
                    </v-icon>
                </v-btn>
            </v-btn-toggle>
        </div>
        <div v-if="isLoading" class="d-flex justify-center mb-4">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col v-for="index in 12" cols="12" md="4">
                            <v-card>
                                <v-skeleton-loader
                                    v-bind="attrs"
                                    type="article"
                                ></v-skeleton-loader>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        <div v-if="toggle_exclusive == 1">
            <v-row dense>
                <v-col v-for="content, index in data" :key="index" md="4" class="">
                    <v-card class="pa-2">
                        <h4 class="d-flex justify-center pa-4">{{ content.name }}</h4>
                        <v-row class="d-flex justify-center">
                            <v-col md="6">
                                <h4 class="d-flex justify-center font-weight-light"><strong>ALTA NUEVA</strong></h4>
                                <v-divider class="mb-2"></v-divider>
                                <div v-if="content.ALTA_NUEVA" class="d-flex justify-center">
                                    <v-icon small left class="mb-1">
                                        mdi-file-sign
                                    </v-icon>
                                    <span>{{ content.ALTA_NUEVA.activaciones }}</span>
                                    <v-icon small class="mx-1"> 
                                        mdi-close
                                    </v-icon>
                                    <span>{{ content.ALTA_NUEVA.upfront }}</span>
                                    <v-icon small class="mb-1">
                                        mdi-currency-eur
                                    </v-icon>
                                    <v-icon small class="mx-1">
                                        mdi-equal
                                    </v-icon>
                                    <span>{{ content.ALTA_NUEVA.activaciones * content.ALTA_NUEVA.upfront }}</span>
                                    <v-icon small class="mb-1">
                                        mdi-currency-eur
                                    </v-icon>
                                </div>
                                <div v-else class="d-flex justify-center">
                                    <v-icon small left class="mb-1">
                                        mdi-file-sign
                                    </v-icon>
                                    <span>0</span>
                                    <v-icon small class="mx-1"> 
                                        mdi-close
                                    </v-icon>
                                    <span>0</span>
                                    <v-icon small class="mb-1">
                                        mdi-currency-eur
                                    </v-icon>
                                    <v-icon small class="mx-1">
                                        mdi-equal
                                    </v-icon>
                                    <span>0</span>
                                    <v-icon small class="mb-1">
                                        mdi-currency-eur
                                    </v-icon>
                                </div>
                            </v-col>
                            <v-col md="6">
                                <h4 class="d-flex justify-center font-weight-light"><strong>PORTA</strong></h4>
                                <v-divider class="mb-2"></v-divider>
                                <div v-if="content.PORTA" class="d-flex justify-center">
                                    <v-icon small left class="mb-1">
                                        mdi-file-sign
                                    </v-icon>
                                    <span>{{ content.PORTA.activaciones }}</span>
                                    <v-icon small class="mx-1"> 
                                        mdi-close
                                    </v-icon>
                                    <span>{{ content.PORTA.upfront }}</span>
                                    <v-icon small class="mb-1">
                                        mdi-currency-eur
                                    </v-icon>
                                    <v-icon small class="mx-1">
                                        mdi-equal
                                    </v-icon>
                                    <span>{{ content.PORTA.activaciones * content.PORTA.upfront }}</span>
                                    <v-icon small class="mb-1">
                                        mdi-currency-eur
                                    </v-icon>
                                </div>
                                <div v-else class="d-flex justify-center">
                                    <v-icon small left class="mb-1">
                                        mdi-file-sign
                                    </v-icon>
                                    <span>0</span>
                                    <v-icon small class="mx-1"> 
                                        mdi-close
                                    </v-icon>
                                    <span>0</span>
                                    <v-icon small class="mb-1">
                                        mdi-currency-eur
                                    </v-icon>
                                    <v-icon small class="mx-1">
                                        mdi-equal
                                    </v-icon>
                                    <span>0</span>
                                    <v-icon small class="mb-1">
                                        mdi-currency-eur
                                    </v-icon>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </div>

        <div v-else>
            <v-data-table
                :headers="headers"
                :items="data"
                class="elevation-3"
                :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                }"
            >
                <template v-slot:item.portabilidad="{ item }">
                    <div v-if="item.PORTA">
                        <v-chip>
                            <v-avatar left>
                                <v-icon small>mdi-file-sign</v-icon>
                            </v-avatar>
                            <span>{{ item.PORTA.activaciones }}</span>
                        </v-chip>

                        <v-icon>
                            mdi-close
                        </v-icon>

                        <v-chip>
                            <span>{{ item.PORTA.upfront }}</span>
                            <v-avatar right>
                                <v-icon small>mdi-currency-eur</v-icon>
                            </v-avatar>
                        </v-chip>

                        <v-icon>
                            mdi-equal
                        </v-icon>

                        <v-chip>
                            <span>{{ item.PORTA.activaciones * item.PORTA.upfront }}</span>
                            <v-avatar right>
                                <v-icon small>mdi-currency-eur</v-icon>
                            </v-avatar>
                        </v-chip>
                    </div>
                </template>
                <template v-slot:item.altaNueva="{ item }">
                    <div v-if="item.PORTA">
                        <v-chip>
                            <v-avatar left>
                                <v-icon small>mdi-file-sign</v-icon>
                            </v-avatar>
                            <span>{{ item.ALTA_NUEVA.activaciones }}</span>
                        </v-chip>

                        <v-icon>
                            mdi-close
                        </v-icon>

                        <v-chip>
                            <span>{{ item.ALTA_NUEVA.upfront }}</span>
                            <v-avatar right>
                                <v-icon small>mdi-currency-eur</v-icon>
                            </v-avatar>
                        </v-chip>

                        <v-icon>
                            mdi-equal
                        </v-icon>

                        <v-chip>
                            <span>{{ item.ALTA_NUEVA.activaciones * item.ALTA_NUEVA.upfront }}</span>
                            <v-avatar right>
                                <v-icon small>mdi-currency-eur</v-icon>
                            </v-avatar>
                        </v-chip>
                    </div>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'LowiSellSummary',
    data: () => ({
        headers: [
            { text: "Name", value: "name" },
            { text: "Portabilidad", value: "portabilidad" },
            { text: "Alta Nueva", value: "altaNueva" },
        ],
        toggle_exclusive: 1,
    }),
    computed: {
        ...mapState('lowi', {
            data: (state) => state.lowi.data,
            isLoading: (state) => state.lowi.isLoading,
        }),
    },
}
</script>
